import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useUser } from "../../context/UserContext";

interface VersionNavigationProps {
    gameId: string | undefined;
    versionId: string | undefined;
}

export const VersionNavigation = ({ gameId, versionId }: VersionNavigationProps) => {
    const { user } = useUser();
    const isAdmin = user?.admin;
    const isTranslater = user?.translater;
    const isTranslaterAdmin = user?.translater_admin;

    // Ne mutasd meg semmit, ha nincs bejelentkezve
    if (!user) {
        return null;
    }

    // "Fordítás" gomb csak fordítóknak, fordító adminoknak és adminoknak
    const canTranslate = isTranslater || isTranslaterAdmin || isAdmin;

    if (!canTranslate) {
        return null;
    }

    return (
        <div className="flex gap-1 mb-6 flex-wrap">
            <Button asChild size="sm">
                <Link to={`/games/${gameId}/versions/${versionId}/translate`}>Fordítás</Link>
            </Button>

            {(isTranslaterAdmin || isAdmin) && (
                <>
                    <Button asChild size="sm">
                        <Link to={`/games/${gameId}/versions/${versionId}/gomb2`}>Tömeges Elfogadás</Link>
                    </Button>
                    <Button asChild size="sm">
                        <Link to={`/games/${gameId}/versions/${versionId}/gomb3`}>OroszRulett</Link>
                    </Button>
                    <Button asChild size="sm">
                        <Link to={`/games/${gameId}/versions/${versionId}/gomb5`}>Ismétlődések</Link>
                    </Button>
                    <Button asChild size="sm">
                        <Link to={`/games/${gameId}/versions/${versionId}/gomb6`}>Szótár</Link>
                    </Button>
                    <Button asChild size="sm">
                        <Link to={`/games/${gameId}/versions/${versionId}/gomb7`}>Lista</Link>
                    </Button>
                    <Button asChild size="sm">
                        <Link to={`/games/${gameId}/versions/${versionId}/gomb8`}>Tömeges cserélő</Link>
                    </Button>
                    <Button asChild size="sm">
                        <Link to={`/games/${gameId}/versions/${versionId}/gomb9`}>Változók</Link>
                    </Button>
                    <Button asChild size="sm">
                        <Link to={`/games/${gameId}/versions/${versionId}/gomb10`}>TömegesFordító</Link>
                    </Button>
                    <Button asChild size="sm">
                        <Link to={`/games/${gameId}/versions/${versionId}/gomb11`}>Azonos</Link>
                    </Button>
                    <Button asChild size="sm">
                        <Link to={`/games/${gameId}/versions/${versionId}/gomb12`}>Sortörés</Link>
                    </Button>
                </>
            )}
        </div>
    );
}; export default VersionNavigation;
